module.exports = __webpack_public_path__ + "static/media/twitter.aa76da08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/AppFooter/assets/twitter.svg
// module id = ./src/common/AppFooter/assets/twitter.svg
// module chunks = 14